import type { $Fetch } from 'ofetch';
import { BaseClient } from '@shared/clients/BaseClient.ts';
import type { Logger } from '@shared/types/types';

export type DominantFacetDTO = {
    attributeName?: string;
    facetValues?: string[];
};

export type WidgetSpinnerRequest = {
    request?: {
        psr: string;
        pageType: 'pl' | 'ses';
        variationIds: string[];
        implicitContext: DominantFacetDTO[];
        explicitContext: DominantFacetDTO[];
    };
    headers?: Record<string, string>;
};

const DEFAULT_TIMEOUT_MS = 300;

export class WidgetSpinnerClient extends BaseClient {
    constructor({
        fetchClient,
        logger,
        baseURL,
        timeout = DEFAULT_TIMEOUT_MS,
    }: {
        fetchClient: $Fetch;
        logger: Logger;
        baseURL?: string;
        timeout?: number;
    }) {
        super(baseURL, fetchClient, logger, timeout);
    }

    async getPromoWidgetSpinner({ request, headers: requestHeaders }: WidgetSpinnerRequest): Promise<string> {
        if (!request?.psr) {
            this.logger.debug("Can't fetch promo widget");
            return '';
        }

        const { psr: dreson } = request;

        const headers = {
            ...(requestHeaders ?? {}),
            'Content-Type': 'application/json',
            Accept: 'text/html',
        };

        try {
            const html = await this.fetch<string>('/promo-widgetspinner/productlist', {
                query: { dreson },
                method: 'POST',
                credentials: 'include',
                headers,
                body: request,
            });
            if (html?.includes('\uFFFD')) {
                this.logger.warn('Promo Widget Spinner response contains non-UTF-8 characters, ignoring');
                return '';
            }
            return html;
        } catch (err) {
            this.logger.info(err, `Error while fetching Promo Widget Spinner`);
            return '';
        }
    }
}
